import { render, staticRenderFns } from "./RemoveAgateProjectConfirmDialog.vue?vue&type=template&id=0160d920&"
import script from "./RemoveAgateProjectConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./RemoveAgateProjectConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports